import { render, staticRenderFns } from "./MypageMain.vue?vue&type=template&id=9589546e&"
import script from "./MypageMain.vue?vue&type=script&lang=js&"
export * from "./MypageMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports